import { API_BASE_URL, getHeaders, handleResponse } from '../apiConfig';

/**
 * Fetch paginated audit logs with filters
 */
export const fetchAuditLogs = async (params = {}) => {
  const query = new URLSearchParams();
  if (params && typeof params === 'object') {
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        query.append(key, params[key]);
      }
    });
  }
  const queryString = query.toString() ? `?${query.toString()}` : '';
  const response = await fetch(`${API_BASE_URL}/audit-logs${queryString}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

/**
 * Fetch aggregated statistics of audit logs
 */
export const fetchAuditStats = async (params = {}) => {
  const query = new URLSearchParams();
  if (params && typeof params === 'object') {
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        query.append(key, params[key]);
      }
    });
  }
  const queryString = query.toString() ? `?${query.toString()}` : '';
  const response = await fetch(`${API_BASE_URL}/audit-logs/stats${queryString}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

/**
 * Explicitly record a client-side action in the audit trail
 */
export const recordAuditLog = async (logData) => {
  const response = await fetch(`${API_BASE_URL}/audit-logs`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(logData)
  });
  return handleResponse(response);
};

/**
 * Clear old audit logs (Admin only)
 */
export const clearAuditLogs = async (days = 90) => {
  const response = await fetch(`${API_BASE_URL}/audit-logs/clear?days=${days}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};
